import React, { useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { FormBlock, StepProps } from '@/widgets/ServiceFormTemplate';

import { ConfirmationOfApplication, PlaceOfResidencePreview, WeaponSelectionPreview } from '@/features/ui';
import { AdditionalDocumentsPreview } from '@/features/ui/Steps/AdditionalDocuments/AdditionalDocuments';
import { useProceedNextFromConfirmation } from '@/features/ui/Steps/ConfirmationOfApplication/utils/useProceedNextFromConfirmation';
import { PersonalAndPassportDataPreview } from '@/features/ui/Steps/PersonalAndPassportData';

import { ConditionView, StepControlPanel } from '@/shared/ui';

import { Loader } from '@/shared/ui';

import { ColdSteelTransportationMergedSchema } from '../../model/types';

import { ContractSecurityActivityPreview } from './ContractSecurityActivity';
import {
  TransportationAndRouteDataPreview,
  TransportationAndRouteDataVehiclePreview,
} from './TransportationAndRouteData';

export interface DataPreviewProps {
  handleGeneratePDF: (formData: ColdSteelTransportationMergedSchema) => Promise<void>;
}

export const DataPreview: React.FC<StepProps<DataPreviewProps>> = ({ next, prev, handleGeneratePDF }) => {
  const { getValues, control } = useFormContext<ColdSteelTransportationMergedSchema>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { proceedNextFromConfirmation } = useProceedNextFromConfirmation(next);

  const confirmEnteredDataCorrect = useWatch({
    control,
    name: 'confirmEnteredDataCorrect',
  });

  const handleNextStep = (): void => {
    setIsLoading(true);

    handleGeneratePDF(getValues())
      .then(proceedNextFromConfirmation)
      .catch(console.error)
      .finally(() => setIsLoading(false));
  };

  return (
    <ConditionView if={!isLoading} else={<Loader />}>
      <FormBlock title="Підтвердження даних">
        <WeaponSelectionPreview />
        <TransportationAndRouteDataVehiclePreview />
        <TransportationAndRouteDataPreview />
        <PersonalAndPassportDataPreview />
        <PlaceOfResidencePreview />
        <ContractSecurityActivityPreview />
        <AdditionalDocumentsPreview />
      </FormBlock>
      <ConfirmationOfApplication />
      <StepControlPanel prev={prev} next={handleNextStep} disabledNext={!confirmEnteredDataCorrect} />
    </ConditionView>
  );
};
